import { render, staticRenderFns } from "./eliminarCuenta.vue?vue&type=template&id=2abf8fc9&scoped=true&"
var script = {}
import style0 from "./eliminarCuenta.vue?vue&type=style&index=0&id=2abf8fc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf8fc9",
  null
  
)

export default component.exports